import i18n from "components/i18n/i18n";
import { ColumnDefinition } from "../columns/ColumnDefinitions";
import { CheckedInfo } from "../tableStatus";
import { CheckInfoColumnElement, initTableCheckInfoColumnWebComponent } from "./checkInfoColumn";

initTableCheckInfoColumnWebComponent();
const template = document.createElement("template");
template.innerHTML = `
  <style>
  .info {
    color: #666666;
    font-size: 90%;
  }
  </style>
  <div class="info" style="display:none;">&nbsp;/ <span class="title"></span><span class="columns"></span></div>
`;

export class CheckInfoElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private cols: ColumnDefinition[];

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.appendChild(template.content.cloneNode(true));
        (this._shadowRoot.querySelector(".title") as HTMLElement).innerText = i18n.t("base.table.checked");
        this.cols = JSON.parse(this.getAttribute("cols"));
    }

    public set info(info: CheckedInfo) {
        this._shadowRoot.querySelector("span.columns").innerHTML = "";
        let elements = [];
        for (const key in info) {
            if (info.hasOwnProperty(key)) {
                if (CheckInfoColumnElement.mustBeDrawn(info[key])) {
                    let element = document.createElement("table-check-info-column") as CheckInfoColumnElement;
                    element.setAttribute("labelKey", this.getColumnKey(key));
                    element.info = info[key];
                    elements.push(element);
                }
            }
        }

        for (const element of elements) {
            this._shadowRoot.querySelector("span.columns").append(element);
        }
        let view = (this._shadowRoot.querySelector("div.info") as HTMLElement);
        if (elements.length > 0) {
            view.style.display = "inline";
        } else {
            view.style.display = "none";
        }
    }

    private getColumnKey(property: string): string {
        for (const col of this.cols) {
            if (col.property === property) {
                return col.tooltipKey ?? col.key;
            }
        }
    }

    public static appendInfoToTable(columns: ColumnDefinition[], tableHolderView: JQuery<HTMLElement>) {
        let cols = JSON.stringify(
            columns
            .filter((c) => c.type === "CheckColumn")
            .map(
                (c) => {
                return {property: c.property, key: c.key, tooltipKey: c.tooltipKey};
                }));
        setTimeout(() => tableHolderView.find(".checkedInfo").append("<table-check-info cols='" + cols + "' >"), 0);
    }
}

export function initTableCheckInfoWebComponent() {
    window.customElements.define("table-check-info", CheckInfoElement);
}
